import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseQuestionIdentifier, QuestionType, ScreensQuestionResource } from '@Components/mras/core';

@Component({
    selector: 'jhi-question-heading',
    templateUrl: './question-heading.component.html',
    styles: []
})
export class QuestionHeadingComponent implements OnInit {
    readonly QuestionType = QuestionType;

    @Input()
    summaryMode: boolean;
    @Input()
    question: ScreensQuestionResource;
    @Output()
    questionChange = new EventEmitter<BaseQuestionIdentifier>();
    @Input()
    questionIdentifier: BaseQuestionIdentifier;

    constructor() {}

    ngOnInit() {}
}
